// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import {Editor} from '../../../shared/editor/editor';
import {Install_btn} from '../ui/install_btn';
import cn from 'classnames';
import {use_screen} from '../lib/screen_util';
import {get_img_url} from './utils';
import styles from './free_vpn_hero.module.less';
import {Agreement_message} from './agreement_message';
import {Link} from '../ui/link';
import {guess_os_and_version} from '../client_hints_global';

interface i_free_vpn_hero_props {
    title: string;
    subtitle: string;
    cta1: string;
    cta2: string;
    render_agreement?: boolean;
    download_vpn?: boolean;
    lp1_layout?: boolean;
}

export const Free_vpn_hero = (props: i_free_vpn_hero_props)=>{
    const {theme} = useContext(Settings_context);
    const {screen} = use_screen();
    const is_mobile = screen=='xs' || screen=='sm';
    const is_desktop = screen=='lg' || screen=='xl';
    const sys = guess_os_and_version();
    const os = sys.os;
    const install_btn_cls = cn(['hola_btn hola_btn--round',
        'hola_btn--txt_colored hola_btn--no_jump hola_btn-no_arrow',
        styles.button], {
          'hola_btn--md': is_mobile,
          'hola_btn--lg': !is_mobile,
        });
    const cta_text = props.cta1 || (os=='macos' ? "Get Hola - it's free"
        : 'Get Hola on your PC');
    const render_header = ()=>{
      if (props.title)
          return <>{props.title}</>;
      if (is_mobile || is_desktop)
          return <>Hola Free VPN<br />for Fast, Easy Access Worldwide</>;
      return <>Hola Free VPN for Fast, Easy Access Worldwide</>;
    };
    const Header_tag = props.lp1_layout ? 'h2' : 'h1';
    return <div className={cn(theme.container, styles.container, {
      [styles.lp1_layout]: props.lp1_layout
    })}>
      <div className={cn(styles.text_container, {
        [styles.padding_top_20]: props.render_agreement
      })}>
        <Header_tag className={cn(styles.header, {
          [styles.header_h2]: props.lp1_layout
        })}>{render_header()}</Header_tag>
        <p className={cn([theme.u2, styles.subtitle])}>
          {props.subtitle}</p>
        <div className={styles.buttons_container}>
          <Install_btn keep_btn_text text={cta_text}
            className={install_btn_cls} app_fixed="vpn"
            no_redirect={!props.download_vpn}
            download_vpn={props.download_vpn}/>
        </div>
        <p className={styles.cta_agreement}>
          By installing this app you agree to the Hola&nbsp;
          <Link to="/legal/sla" target="_blank">End User Agreement</Link>
          &nbsp;&&nbsp;
          <Link to="/legal/privacy" target="_blank">Privacy Statement</Link>
        </p>
        {props.render_agreement && <div className={styles.agreement_container}>
          <Agreement_message />
        </div>}
      </div>
      <div className={styles.image_container}>
        <img src={get_img_url('free_portal.png')}
          alt="desktop" className="lazyload"/>
      </div>
    </div>;
};

interface i_free_vpn_hero_editor_props {
    value: i_free_vpn_hero_props;
    on_change: (value: i_free_vpn_hero_props)=>void;
}

export const Free_vpn_hero_editor = (props: i_free_vpn_hero_editor_props)=>{
    return <Editor value={props.value} on_change={props.on_change}
      editors={[
        {key: 'title', type: 'text', label: 'Title'},
        {key: 'subtitle', type: 'text', label: 'Subtitle'},
        {key: 'cta1', type: 'text', label: 'CTA 1'},
        {key: 'cta2', type: 'text', label: 'CTA 2'},
        {key: 'render_agreement', type: 'boolean',
          label: 'Render agreement message'},
        {key: 'download_vpn', type: 'boolean', label: 'Download VPN'},
        {key: 'lp1_layout', type: 'boolean',
          label: 'LP1 layout (content left, image right)'},
      ]} />;
};
